<template>
    <div class="coop-solution-box">
        <section-title main="我们提供全套运营解决方案" sub="针对机构招生+续费提升的难题"></section-title>
        <div class="content">
            <img class="bg-img" src="https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/home/home-2-bg.png">
            <div class="detail-box">
                <div class="content-item" v-for="(item, index) in objData" :key="index">
                    <p class="title"><span>{{item.type_name}}</span></p>
                    <div class="child-list">
                        <div class="child-item" v-for="(child, cIndex) in item.list" :key="cIndex">
                            <p class="child-title">{{child.index}}.{{child.name}}</p>
                            <div class="son-box">
                                <div class="son-item" v-for="(son, sIndex) in child.children" :key="sIndex">
                                    <coop-item :vm="son" :isFirst="(index ==0 && cIndex ===0 && sIndex ===0)"></coop-item>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { solutionList } from '@/const'
import coopItem from './coop-item'
export default {
    data () {
        return {
            objData: solutionList
        }
    },
    components: { coopItem }
}
</script>
<style lang="scss" scoped>
.coop-solution-box{
    .content{
        margin-top: -30px;
        .bg-img{
            width: 100%;
        }
        .detail-box{
            margin-top: -50px;
            .content-item{
                text-align: left;
                .title{
                    width:97px;
                    height:30px;
                    background:rgba(1,130,255,1);
                    border-radius:0px 19px 19px 0px;
                    font-size:14px;
                    font-family:PingFangSC-Medium,PingFang SC;
                    font-weight:500;
                    color:rgba(255,255,255,1);
                    line-height:20px;
                    padding: 0px 15px 0px 12px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    position: -webkit-sticky; /* Safari */
                    position: sticky;
                    top: 50px;
                }
                .child-list{
                    padding: 0px 30px 0px 20px;
                    margin-top: 20px;
                    .child-item{
                        .child-title{
                            font-size:14px;
                            font-family:PingFangSC-Medium;
                            font-weight:500;
                            color:#272727;
                            line-height:20px;
                        }
                        .son-box{
                            padding-left: 20px;
                            margin-bottom: 18px;
                        }
                    }
                }
                &:last-of-type{
                    margin-bottom: 0px;
                }  
            }
        }
    }
}
</style>